import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Typography from '@mui/material/Typography';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { Grid, List,ListItem,ListItemButton,ListItemText } from '@mui/material';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import CurrencyBitcoinRoundedIcon from '@mui/icons-material/CurrencyBitcoinRounded';
import { SliderComponent } from '../../Component/Component';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
    {
      label: 'San Francisco – Oakland Bay Bridge, United States',
      imgPath:
        'https://cdn.vox-cdn.com/thumbor/2V6dYMtY4mOs3N8Qyo8MLpepA20=/93x0:1600x1005/920x613/filters:focal(93x0:1600x1005):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/49112139/witcher3_en_wallpaper_wallpaper_10_1920x1200_1433327727.0.0.jpg',
    },
    {
      label: 'The Witcher 3',
      imgPath:
        'https://pbs.twimg.com/media/FTIN491VEAAA7eQ.jpg',
    },
    {
      label: 'San Francisco – Oakland Bay Bridge, United States',
      imgPath:
        'https://cdn.vox-cdn.com/thumbor/2V6dYMtY4mOs3N8Qyo8MLpepA20=/93x0:1600x1005/920x613/filters:focal(93x0:1600x1005):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/49112139/witcher3_en_wallpaper_wallpaper_10_1920x1200_1433327727.0.0.jpg',
    },
    {
      label: 'The Witcher 3',
      imgPath:
        'https://pbs.twimg.com/media/FTIN491VEAAA7eQ.jpg',
    },
  ];

const GameSlider = () => {
    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = images.length;
  
    const handleStepChange = (step) => {
      setActiveStep(step);
    };
  
    return (
        <Grid container sx={{ maxWidth: '100%',marginLeft:'5%',marginRight:'5%',marginTop:'5%',display:'flex' }}>
            <Grid item md={12} lg={12} xl={12}>
        <AutoPlaySwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {images.map((step, index) => (
            <Box key={step.label}>
              {Math.abs(activeStep - index) <= 2 ? (
                <SliderComponent
                sx={{
                  height: "500px",
                  display: "block",
                  overflow: "hidden",
                  objectFit: "cover",
                  width: "100%",
                }}
              >
                <Box
                  component="img"
                  src={step.imgPath}
                  alt={step.label}
                  sx={{ objectFit: "cover", width: "100%", height: "100%" }}
                />
              </SliderComponent>
                
              ) : null}
            </Box>
          ))}
        </AutoPlaySwipeableViews>
        </Grid>
      {/* </Box> */}
      <Grid item md={12} lg={12} xl={12} sx={{ zIndex: 1,marginTop: '-24.5%',display:'flex',flexDirection:'column'}}>
        <item>
      <MobileStepper
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          sx={{background:'transparent'}}
        />
        </item>
        <item>
                <Box sx={{display:'flex',flexDirection:'row',padding:'10px',background:'linear-gradient(to right, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 43%, rgba(0, 0, 0, 0.1) 100%)',width:'40%'}}>
                <StarRoundedIcon sx={{color:'black',backgroundColor:'yellow',borderRadius:'20px',padding:'1px'}} />
                <Typography variant='body2' sx={{margin:'5px',marginLeft:'15px'}}>5.0 (51 Ratings)</Typography>
                <Typography sx={{color:'#0054ff',margin:'5px',marginLeft:'15px'}}>Fizen Ltd</Typography>
                <CurrencyBitcoinRoundedIcon sx={{color:'black',backgroundColor:'yellow',borderRadius:'20px',padding:'1px',marginLeft:'15px'}} />
                <Typography variant='body2' sx={{margin:'5px',marginLeft:'15px'}}>BSC</Typography>
                </Box>
        </item>
        <item>
        <Box sx={{background:'rgb(106,115,210,0.8)',borderBottomLeftRadius:'20px',borderBottomRightRadius:'20px', height:'170px', width:'100%'}}>
        <Grid container sx={{display:'flex', justifyContent:'center',alignItems:'center',paddingLeft:'4%'}}>
            <Grid item xs={8} sm={8} md={8} lg={8} xl={8}  >
                <item><Typography>Monsterra</Typography></item>
                <item><Typography>In Cult of the Lamb, the player character, an adorable but possessed lamb, has their life saved by an ominous deity; as repayment, they must form a cult to appease the deity, growing its following by launching crusades.</Typography></item>
            </Grid>
            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <List>
                    <ListItem sx={{borderLeft:'1px solid white'}}>
                        <ListItemText>
                            <Typography variant='body2'>Release Status:</Typography>
                            <Typography variant='caption'>Testnet</Typography>
                        </ListItemText>
                    </ListItem>
                    <ListItem sx={{borderLeft:'1px solid white'}}>
                        <ListItemText>
                            <Typography variant='body2'>Categories:</Typography>
                            <Typography variant='caption'>Adventure, Turn-based, Idle</Typography>
                        </ListItemText>
                    </ListItem>
                </List>
            </Grid>
            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} sx={{borderLeft:'1px solid white'}}> 
                <List>
                    <ListItemButton>
                        <ArrowCircleRightOutlinedIcon sx={{fontSize:'4rem'}} />
                    </ListItemButton>
                    <ListItem>
                        <ListItemText>
                            <Typography variant='body2'>Read More</Typography>
                        </ListItemText>
                    </ListItem>
                </List>
            </Grid>
        </Grid>
        </Box>
        </item>
        </Grid>
      </Grid>
    );
};
export default GameSlider